import type { AuthStoreTypes } from '@/stores/authStore'

export async function getAuthStoreSnapshot(): Promise<AuthStoreTypes> {
  const { default: useAuthStore } = await import('@/stores/authStore')
  return useAuthStore.getState()
}
